import { render, staticRenderFns } from "./AdoptionReportEditorPropagandist.vue?vue&type=template&id=37c8e54e&"
import script from "./AdoptionReportEditorPropagandist.vue?vue&type=script&lang=js&"
export * from "./AdoptionReportEditorPropagandist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports